module.exports = __webpack_public_path__ + "static/img/22.5ee64365.png";